import { useEffect, useRef, useState } from 'react';

export default function HeroSection() {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setVisible(true);
  }, []);

  const scrollDown = () => {
    const el = document.getElementById('facilities');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      ref={sectionRef}
      className="relative w-full h-screen min-h-[600px] overflow-hidden"
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=elegant%20luxury%20perfume%20boutique%20interior%20with%20glass%20display%20shelves%20warm%20golden%20lighting%20minimalist%20high%20end%20showroom%20dark%20sophisticated%20atmosphere%20professional%20fragrance%20retail%20space&width=1400&height=900&seq=hero-bg&orientation=landscape)',
        }}
      />

      {/* Dark Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60" />

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full px-6 text-center">
        <div
          className={`transition-all duration-1000 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight mb-4">
            En esencia & Co
          </h1>
          <div className="w-16 h-0.5 bg-white/60 mx-auto mb-6" />
        </div>

        <button
          onClick={scrollDown}
          className={`mt-4 transition-all duration-1000 delay-500 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
          aria-label="Scroll down"
        >
          <div className="flex flex-col items-center gap-1.5 animate-bounce">
            <div className="w-5 h-5 border-r border-b border-white/80 rotate-45" />
            <div className="w-5 h-5 border-r border-b border-white/60 rotate-45 -mt-3" />
          </div>
        </button>
      </div>

      {/* Bottom Paragraph */}
      <div
        className={`absolute bottom-8 left-0 right-0 px-6 md:px-16 lg:px-24 transition-all duration-1000 delay-700 ${
          visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
        }`}
      >
        <p className="text-white/80 text-sm md:text-base max-w-3xl mx-auto text-center leading-relaxed">
          Somos la empresa líder en distribución de insumos para perfumería fina en Latinoamérica. Comercializamos al por mayor y al detal extractos, envases y accesorios que impulsan el éxito de negocios de perfumería en toda la región.
        </p>
      </div>
    </section>
  );
}